/** Shared rows-per-page options (aligned with Clients page). */
export const ROWS_PER_PAGE_VALUES = [10, 20, 50, 100];

export const rowsPerPageSelectOptions = ROWS_PER_PAGE_VALUES.map((n) => ({
    value: n,
    label: String(n),
}));

export const DEFAULT_ROWS_PER_PAGE = 20;

/**
 * Maps localStorage or legacy values to a valid option (e.g. old menu 8/16/24).
 * @param {string|number|null|undefined} stored
 * @returns {number}
 */
export function normalizeRowsPerPage(stored) {
    const n = typeof stored === "number" ? stored : parseInt(String(stored), 10);
    if (Number.isFinite(n) && ROWS_PER_PAGE_VALUES.includes(n)) {
        return n;
    }
    if (n === 8) return 10;
    if (n === 16) return 20;
    if (n === 24) return 20;
    return DEFAULT_ROWS_PER_PAGE;
}
